<div class="contract-list-container">
    <div class="card">
        <div class="card-header col-sm-12">
            <div style="margin-top: 10px; float: left">
                <h5>Allocated File Numbers List</h5>
            </div>
        </div>
        <div class="card-body">
            <div>
                <form class="form-horizontal">
                    <div style="border:solid 1px transparent;">
                        <div class="container-fluid">
                            <div class="contract-list-alignment">
                                <div class="contract-date-picker">
                                    <div class="row">
                                        <div class="form-group col-lg-10 col-md-12 col-sm-12">
                                            <mat-form-field class="block-input">
                                                <input id="search" class="mat-search" matInput (keyup)="applyFilter($event.target.value)" placeholder="Search by all fields...">
                                            </mat-form-field>
                                        </div>
                                        <div class="form-group col-lg-2" *ngIf="clpUserId === 0">
                                            <span>Sales Person</span>
                                            <select id="clpUserName" class="custom-select" (change)="filterFileNumberList($event.target.value)">
                                                <option [value]="0">All</option>
                                                <option *ngFor="let user of clpUserNameList" [value]="user.clpUserId">{{user.clpUserName}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mat-container mat-elevation-z2 mb-0">
                        <div class="contract-list-table">

                            <mat-table matTableExporter [dataSource]="dataSource" matSort matSortStart="asc">
                                <ng-container matColumnDef="inventionName">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>Invention </mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        <span class="mobile-label">Invention</span>
                                        <span class="invention-name">{{element.inventionName}}</span>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="assignedFileNumber">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>Assigned File Number</mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        <span class="mobile-label">Product</span>
                                        <span class="invention-name">{{element.assignedFileNumber}}</span>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="completeFileNumber">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>Complete File Number</mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        <span class="mobile-label">Complete File Number</span>
                                        <span class="invention-name">{{element.completeFileNumber}}</span>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="assignedDate">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>Assigned Date</mat-header-cell>
                                    <mat-cell *matCellDef="let element">
                                        <span class="mobile-label">Assigned Date</span>
                                        <span class="invention-name">{{element.assignedDate | date: 'MM/dd/yyyy h:mma'}}</span>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                            </mat-table>
                            <mat-progress-bar *ngIf="isLoading" class="green-progress" mode="query" value="40"></mat-progress-bar>
                            <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="pageSize" (page)="pageEvent = handlePage($event)" showFirstLastButtons></mat-paginator>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
